import React from "react";
import AlumnoLayout from "@/components/AlumnoLayout";
import { useAuth } from "@/context/AuthContext";
import MessagesInbox from "@/components/MessagesInbox";

export default function AlumnoMensajes() {
  const { user } = useAuth();
  return (
    <AlumnoLayout user={user}>
      <div className="mb-4">
        <p className="text-xs uppercase tracking-widest text-[#F26A21] font-bold">Alumno</p>
        <h1 className="mt-1 text-3xl font-bold text-white font-display">Mensajes</h1>
        <p className="mt-1 text-sm text-gray-400">Habla con tus instructores.</p>
      </div>
      <MessagesInbox role="alumno" />
    </AlumnoLayout>
  );
}
